import React, { Component } from 'react';
import ApplicationFlowRouter from './routers';
import GlobalAlert from './components/GlobalAlert';

class App extends Component {
    render() {
        return (
            <>
                <GlobalAlert />
                <ApplicationFlowRouter />
            </>
        );
    }
}

export default App;
